<template>
	<div>
		<v-alert v-if="localData.userLoanModel != null" icon="mdi-shield-lock-outline" prominent text type="info">
			<v-row>
				<v-col cols="12" md="12">
					{{ localData.userLoanModel.loanModel.title }}
					<br>
					(شماره وام: {{ localData.userLoanModel.code }})
					<br>
					{{ localData.userLoanModel.amount.toString().toPriceFormat() }} تومان
				</v-col>
				<v-col cols="12" md="12">
					{{ localData.userLoanModel.month }} قسط:
					<br>
					{{ localData.userLoanModel.installment.toString().toPriceFormat() }} تومان
				</v-col>
				<v-col cols="12" md="12">
					باقیمانده:
					<br>
					{{ localData.userLoanModel.remain.toString().toPriceFormat() }} تومان
				</v-col>
			</v-row>
		</v-alert>

		<v-form ref="form" class="mx-2" lazy-validation>
			<v-row>
				<v-col cols="12" md="12" class="">
					<v-text-money ref="amount" v-model="localData.installmentAmount" :label="'*مبلغ قسط'" :error-messages="errorMessages" :rules="[() => localData.installmentAmount > 0 || 'مبلغ قسط را به صورت صحیح وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="12" class="py-0">
					<v-text-money ref="discount" v-model="localData.discount" :label="'تخفیف'" :error-messages="errorMessages" :rules="[() => localData.discount >= 0 || 'مبلغ تخفیف را به صورت صحیح وارد کنید']" required />
				</v-col>
				<v-col cols="12" md="12">
					<div class="mb-5 pb-5">
						<div>تاریخ سررسید</div>
						<date-picker ref="targetMonth" v-model="localData.targetMonth" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :rules="[() => !!localData.targetMonth || 'تاریخ سررسید را به صورت صحیح وارد کنید']" />
					</div>
				</v-col>
			</v-row>
		</v-form>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark :loading="submitLoading" @click="submit()">
				ذخیره
			</v-btn>
		</v-card-actions>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
import { emptyId } from '@/util/emptyId'
import api from '@/util/app-api'
import toast from '@/util/toast'
import { get } from 'vuex-pathify'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
	name: 'ModifyLoanPaymentView',
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		'date-picker': VuePersianDatetimePicker,
	},
	props: {
		data: { type: Object },
	},
	data() {
		return {
			errorMessages: '',
			localData: { paymentMethod: { id: 1, title: 'نقدی' } },
			submitLoading: false,
			targetMonth: '',
			initValue: 0,
		}
	},
	computed: {
		...get('appSettings', [
			'settings',
		])
	},
	mounted() {
		this.prepareData()
	},
	methods: {
		async submit() {
			if (!this.$refs.form.validate()) { return }
			this.submitLoading = true
			let data = {}
			Object.assign(data, this.localData)
			data.sendSms = false
			api.post('admin/loanpayment/edit', data)
				.then(
					response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.$emit('callbck', true)
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.submitLoading = false })
		},
		prepareData() {
			if (!this.data) {
				toast.error('آیتم یافت نشد.')
				return
			}
			api.get('admin/loanpayment/get/' + this.data.id, null)
				.then(
					response => {
						this.localData = response
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
	},
}
</script>
<style></style>
